import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  AuthService,
  RoutingService
} from '@spartacus/core';
import {
  FocusConfig,
  ICON_TYPE, LaunchDialogService
} from '@spartacus/storefront';
import {
  BehaviorSubject,
  filter,
  map,
  Observable,
  of,
  Subscription
} from 'rxjs';
import { UigLegalService } from '../uig-legal.service';
import { UserAccountService } from '@spartacus/user/account/core';
import { UigB2BUser } from 'src/app/organization/uig-user/uig-user.model';
import { UserAccountFacade } from '@spartacus/user/account/root';

@Component({
    selector: 'app-uig-terms-conditions-dialog',
    templateUrl: './uig-terms-conditions-dialog.component.html',
    styleUrls: ['./uig-terms-conditions-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigTermsConditionsDialogComponent implements OnInit, OnDestroy {
  @HostBinding('attr.role') role = 'dialog';
  @HostBinding('attr.aria-modal') modal = true;

  @Input() redirectToLogin: boolean;

  private subscription: Subscription = new Subscription();

  public iconTypes = ICON_TYPE;

  public loading$: Observable<boolean>;

  public accepted$=  new BehaviorSubject(false);

  public dialogData$ = this.launchDialogService.data$;


  public focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'input[type="checkbox"]',
    focusOnEscape: true,
  };

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.dismissModal('Cross click');
    }
  }

  constructor(
    private el: ElementRef,
    private launchDialogService: LaunchDialogService,
    private uigLegalService: UigLegalService,
    private authService: AuthService,
    private routingService: RoutingService,
    private userAccountFacade: UserAccountFacade,
  ) { }   

  ngOnInit(): void {
    this.loading$ = of(false);
    this.onLogin();
  }

  private completeTermsAccept(): void {
    this.close('completeTermsAccept');
    window.location.reload();
  }

  private completeTermsDecline(): void {
    this.authService.coreLogout().then(
      () => { this.routingService.go({ cxRoute: 'login' }); }
    );
    this.close('completeTermsDecline');
  }

  public close(reason?: any, redirectToLogin?: boolean): void {
    this.launchDialogService.closeDialog(reason);
    if (redirectToLogin) {
      this.authService.coreLogout().then(
        () => { this.routingService.go({ cxRoute: 'login' }); }
      );
    }
  }

  public termsAndConditionsAccept(): void {
    this.subscription.add(
      this.uigLegalService
        .termsAndConditionsAccept()
        .subscribe({
          next: res => this.completeTermsAccept(),
          error: err => this.completeTermsAccept()
        })
    );
  }

  onLogin(): void {
    this.subscription.add(
      this.userAccountFacade
        .get()
        .pipe(
          filter((user: UigB2BUser) => user !== undefined)
        )
        .subscribe((user:UigB2BUser) => {
          if (user.hasAcceptedTermsAndConditions === false) {
            this.accepted$.next(false);
          } else {
            this.accepted$.next(true);
          }
        })
    );
  }

  public termsAndConditionsDecline(): void {
    this.subscription.add(
      this.uigLegalService
        .termsAndConditionsDecline()
        .subscribe({
          next: res => this.completeTermsDecline(),
          error: err => this.completeTermsDecline()
        })
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  dismissModal(reason?: any): void {
    this.launchDialogService.closeDialog(reason);
  }
}
